exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#emailtemplatesLoader{position:absolute;top:0;left:0;width:100%;height:100%;min-height:640px;min-height:50vh;background-color:hsla(0,0%,88.2%,.7);z-index:100}#emailTemplatesEditor .slide-fade-enter-active{transition:all .4s ease}#emailTemplatesEditor .slide-fade-leave-active{transition:all .4s cubic-bezier(1,.5,.8,1)}#emailTemplatesEditor .slide-fade-enter{transform:translateX(-10px);opacity:0}#emailTemplatesEditor .slide-fade-enter-to{transform:translateX(0);opacity:1}#emailTemplatesEditor .slide-fade-leave-to{transform:translateX(10px);opacity:0}", ""]);

// exports
